import { memo, useEffect, useState } from "react";
import { useAuth } from "../../context/loginContext.js";
import { useDashboard } from "../../context/dashboardContext.js";
import { Link, useLocation,useNavigate } from "react-router-dom";
import Cookie from "js-cookie";


const NavBar = () => {

    //contexto de sesion
    const { setUser, setUser_autenticado, utlexp, user } = useAuth();
    //contexto de dash
    const { apartados, setApartados } = useDashboard();
    const navigate = useNavigate();

    //const [apartados, setApartados] = useState("");
    let location = useLocation();

    const menu_on_off = () => {
        if (document.getElementById("body_main").classList.contains('sb-sidenav-toggled')) {
            document.getElementById("body_main").classList.remove("sb-sidenav-toggled");
        } else {
            document.getElementById("body_main").classList.add("sb-sidenav-toggled");
        }
    }

    const cerrar_sesion = () => {
        Cookie.remove("AutKeyPbi");
        setUser_autenticado(false);
        setApartados([])
        navigate("/login");
        //window.location.href = window.location.href;

    }


    return (
        <nav className="navbar navbar-expand bg-body-secondary sticky-top border-bottom nav-somb">

            <div className="container-fluid ">
                <ul className="navbar-nav">
                    {/* Navbar*/}
                    
                    <li className="nav-item dropdown me-3">
                        <button className="btn-mnu" data-bs-toggle="offcanvas" data-bs-target="#offcanvasWithBothOptions" aria-controls="offcanvasWithBothOptions" ><i className="ion-ios-list-outline"></i></button>
                    </li>
                    
                </ul>


                <ul className="navbar-nav me-3 me-lg-4">
                    <li className="nav-item dropdown">
                        <button className={"nav-link "} id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                            <div className="sb-nav-link-icon dropdown-toggle"><i className="bi bi-person-circle"></i></div>
                        </button>
                        <ul className="dropdown-menu dropdown-menu-end" aria-labelledby="navbarDropdown">
                            <li className="text-center"><label className="overflow-ellipsis">{user !== null ? user.nombre : "---"}</label></li>
                            <li><button className="dropdown-item hove_option" onClick={() => { cerrar_sesion() }} ><i className="bi bi-power"></i> Salir</button></li>
                        </ul>
                    </li>
                </ul>
            </div>

        </nav>
    );

}

export default memo(NavBar);
